<template>
  <v-tooltip top :disabled="isDateAvailable && isRoomAvailable" max-width=300>
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on">
        <v-btn
          :disabled="!isDateAvailable || !isRoomAvailable"
          @click="$emit('start-reservation')"
          block
          outlined
          color="primary"
          class="primary-gradient">
          {{ reservationMethod.callToAction }}
        </v-btn>
      </div>
    </template>
    <span>{{
      isDateAvailable
        ? $t('activity_reservation.warning.reservation_method_no_room')
        : !validBookings
          ? $t('activity_reservation.warning.no_checkin_or_checkout')
          : lastValidDate
            ? $t('activity_reservation.warning.reservation_method_first_date', {
                date: moment(firstValidDate).format('L'),
                hour: moment(firstValidDate).format('HH:mm')
              })
            : $t('activity_reservation.warning.no_booking')
    }}</span>
  </v-tooltip>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    reservationMethod: Object,
    bookings: Array,
  },
  data () {
    return {
      moment,
    }
  },
  created () {
    moment.locale(this.$i18n.locale)
  },
  computed: {
    ...mapGetters({
      firstCheckIn: 'me/firstCheckIn',
      lastCheckOut: 'me/lastCheckOut',
      validBookings: 'me/validBookings',
      rooms: 'me/allRooms',
    }),
    firstValidDate () {
      return this.validBookings
        ? this.reservationMethod.mustHaveCheckedIn
          ? moment(this.firstCheckIn)
          : moment(this.firstCheckIn).subtract(this.reservationMethod.leewayBeforeCheckIn, 'ms')
        : null
    },
    lastValidDate () {
      return this.validBookings && moment().isBefore(this.lastCheckOut)
        ? moment(this.lastCheckOut)
        : null
    },
    isDateAvailable () {
      return !!this.firstValidDate && moment().isAfter(this.firstValidDate) && !!this.lastValidDate
    },
    isRoomAvailable () {
      if (this.reservationMethod.type === 'ROOM_SERVICE') {
        return !!this.rooms.length
      }
      return true
    },
  },
}
</script>
